import { translations } from "@/features/i18n/translations";
import { type I18nTFunctionBound } from "@/types/customTypes";

type Locale = "en" | "ru" | "pt";

export function getTranslation(
  locale: Locale,
  key: Parameters<I18nTFunctionBound>[0],
): string {
  const keys = key.split(":");
  if (keys.length < 2) {
    console.warn(
      `Invalid translation key format: ${key}. Expected format: "namespace:key" or "namespace:key:subkey"`,
    );
    return key;
  }

  const [namespace, ...keyParts] = keys;
  const translationKey = keyParts.join(":");

  if (!namespace || !translationKey) {
    console.warn(
      `Invalid translation key format: ${key}. Expected format: "namespace:key" or "namespace:key:subkey"`,
    );
    return key;
  }

  // Navigate through the nested object structure
  const namespaceTranslations =
    translations[locale]?.[
      namespace as keyof (typeof translations)[typeof locale]
    ];
  if (!namespaceTranslations) {
    console.warn(`Namespace "${namespace}" not found for locale "${locale}"`);
    return key;
  }

  const translation = (namespaceTranslations as Record<string, string>)[
    translationKey
  ];
  if (typeof translation !== "string") {
    console.warn(
      `Translation key "${translationKey}" not found in namespace "${namespace}" for locale "${locale}"`,
    );
    return key;
  }

  return translation;
}
